import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import useCampaignClearEffects from '../useCampaignClearEffects'
import usePermissions from '../../../../hooks/usePermissions'

import { insertIf } from '../../../../helpers/common'

import { openForm } from '../../../../modules/actions/forms'
import { updateCampaign } from '../../../../modules/actions/campaigns'
import { selectedDV360AdAccountSelector } from '../../../../modules/selectors/adAccounts'

import { CAMPAIGN_DV360_EDIT, CHANGE_CAMPAIGN_HISTORY } from '../../../../constants/forms'
import { listItemChangeStatus } from '../../../../constants/other'
import { HISTORY_META_EDIT_SECTION } from '../../../../constants/changeHistory'
import { DV_360_PLATFORM } from '../../../../constants/selectLists/platformList'

const useGetDv360CampaignActions = () => {
  const dispatch = useDispatch()

  const permissions = usePermissions()

  const { id: dv360AdAccountId } = useSelector(selectedDV360AdAccountSelector)

  useCampaignClearEffects()

  return useCallback(
    ({ id, status }) => {
      return [
        ...insertIf(permissions.can('update', 'Campaign'), {
          text: 'Edit',
          onClickHandler: () => dispatch(openForm({ id, formName: CAMPAIGN_DV360_EDIT }))
        }),
        ...insertIf(permissions.can('update', 'Campaign'), {
          text: status === 'active' ? 'Pause' : 'Activate',
          onClickHandler: () => {
            dispatch(
              updateCampaign(
                {
                  status: listItemChangeStatus[status].changeTo,
                  account: dv360AdAccountId,
                  meta: {
                    [HISTORY_META_EDIT_SECTION]: 'Status'
                  }
                },
                id,
                DV_360_PLATFORM
              )
            )
          }
        }),
        {
          text: 'Change History',
          onClickHandler: () => dispatch(openForm({ id, formName: CHANGE_CAMPAIGN_HISTORY }))
        }
      ]
    },
    [dispatch, dv360AdAccountId, permissions]
  )
}

export default useGetDv360CampaignActions
